import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Label, Input } from 'reactstrap';
import { Checkbox } from '@mui/material';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { If, Then, Else } from 'react-if';
import { slideDrawer } from '../../reducers/UIReducer/UIActions';
import { FiX, FiEye, FiEyeOff } from 'react-icons/fi';
import { isMobile } from 'react-device-detect';
import { Theme, selectStyles, roleOptions } from '../../config/constants';
import { FaUserAltSlash } from 'react-icons/fa';
import userApi from '../../api/userApi';
import LocalStorage from '../LocalStorage/LocalStorage';
import useUsersRoles from "../../AppMain/Settings/UsersRoles/useUsersRoles";


const EditUserSlideDrawer = (props) => {
  const dispatch = useDispatch();
  const { userDelete } = useUsersRoles.useApi();
  const enabled = useSelector(({ui}) => ui.editUserSlideDrawer);
  const isInternalAdmin = LocalStorage.userData.get().user.internalAdmin;
  const canDelete = props.allowDelete ?? isInternalAdmin;
  const [user, setUser] = useState(props.user);
  const [role, setRole] = useState([]);
  const [email, setEmail] = useState(props.user.email);
  const [dashboardAccess, setDashboardAccess] = useState(props.user.dashboard);
  const [salesStreamAccess, setSalesStreamAccess] = useState(props.user.chainData || props.user.emergingData);
  const [mfrItemScoreAccess, setMfrItemScoreAccess] = useState(props.user.itemScore);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [emailError, setEmailError] = useState('');
//   const [newLocationsApp, setNewLocationsApp] = useState(false);
//   const [newLocationsEmail, setNewLocationsEmail] = useState(false);
//   const [lostLocationsApp, setLostLocationsApp] = useState(false);
//   const [lostLocationsEmail, setLostLocationsEmail] = useState(false);
//   const [productChangesApp, setProductChangesApp] = useState(false);
//   const [productChangesEmail, setProductChangesEmail] = useState(false);
//   const [categoryChangesApp, setCategoryChangesApp] = useState(false);
//   const [categoryChangesEmail, setCategoryChangesEmail] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleClickDeactivateUser = () => {
    dispatch(slideDrawer.subtractEditUser());
    userDelete(props.user, props.refreshCb);
  }

  const handleSave = () => {
    if (!validateEmail(email)) {
      setEmailError('Invalid email format');
      return;
    }
    if (password !== confirmPassword) {
      setPasswordError('Passwords do not match');
      return;
    }
    let updatedUser = user;
    updatedUser.title = role.label;
    updatedUser.email = email;
    if (isInternalAdmin) {
        updatedUser.dashboard = dashboardAccess;
        updatedUser.chainData = salesStreamAccess;
        updatedUser.emergingData = salesStreamAccess;
        updatedUser.itemScore = mfrItemScoreAccess;
    }
    props.adminLoginData.onAdminEditUser(updatedUser, props.manufacturer.value);
    if (password && confirmPassword) {
        userApi.adminChangePassword.post({newPassword: password}, props.user.id).catch(err => {
              console.error(err);
        });
    };
    // const userAlertPreferences = {
    //     userId: props.user.id, 
    //     preferences: [
    //         {
    //             alertTypeId: 1,
    //             preference: newLocationsApp && newLocationsEmail ? 'both' : newLocationsApp ? 'app' : newLocationsEmail ? 'email' : 'none'
    //         },
    //         {
    //             alertTypeId: 2,
    //             preference: lostLocationsApp && lostLocationsEmail ? 'both' : lostLocationsApp ? 'app' : lostLocationsEmail ? 'email' : 'none'
    //         },
    //         {
    //             alertTypeId: 3,
    //             preference: productChangesApp && productChangesEmail ? 'both' : productChangesApp ? 'app' : productChangesEmail ? 'email' : 'none'
    //         },
    //         {
    //             alertTypeId: 4,
    //             preference: categoryChangesApp && categoryChangesEmail ? 'both' : categoryChangesApp ? 'app' : categoryChangesEmail ? 'email' : 'none'
    //         }
    //     ]
    // };
    // userApi.alertPreferences.post(userAlertPreferences).catch(err => {
    //     console.error(err);
    // });
    setPasswordError('');
    setEmailError('');
  };

//   const getUserAlertPreferences = (userId) => {
//     if (!userId) return;
//     userApi.alertPreferences.get(userId).then(({data}) => {
//         setNewLocationsApp(data.find((pref) => pref.alertTypeId === 1).preference === "both" || data[0].preference === "app");
//         setNewLocationsEmail(data.find((pref) => pref.alertTypeId === 1).preference === "both" || data[0].preference === "email");
//         setLostLocationsApp(data.find((pref) => pref.alertTypeId === 2).preference === "both" || data[1].preference === "app");
//         setLostLocationsEmail(data.find((pref) => pref.alertTypeId === 2).preference === "both" || data[1].preference === "email");
//         setProductChangesApp(data.find((pref) => pref.alertTypeId === 3).preference === "both" || data[2].preference === "app");
//         setProductChangesEmail(data.find((pref) => pref.alertTypeId === 3).preference === "both" || data[2].preference === "email");
//         setCategoryChangesApp(data.find((pref) => pref.alertTypeId === 4).preference === "both" || data[3].preference === "app");
//         setCategoryChangesEmail(data.find((pref) => pref.alertTypeId === 4).preference === "both" || data[3].preference === "email");
//     }).catch(err => {
//         console.error(err);
//     });
//   };

  const onCloseDrawer = () => {
    setPasswordError('');
    setEmailError('');
    dispatch(slideDrawer.subtractEditUser());
};

  useEffect(() => {
    if (!props.user) return;
    setRole(roleOptions.find((roles) => roles.label === props.user.title) || roleOptions.find((roles) => roles.label === 'Read Only'));
    setDashboardAccess(props.user.dashboard || false);
    setSalesStreamAccess(props.user.chainData || props.user.emergingData || false);
    setMfrItemScoreAccess(props.user.itemScore || false);
    setEmail(props.user.email || false);
    setUser(props.user);
    //getUserAlertPreferences(props.user.id);
    // eslint-disable-next-line
  }, [props.user]);

  return (
    <If condition={enabled}>
    <Then>
      <div className="mask" style={{backgroundColor: 'rgba(0, 0, 0, 0.3)'}}>
        <div className={(isMobile ? "side-drawer-mobile open" : "side-drawer open")}>
            <Row className="m-3 mt-4">
                <Col className="w-fc text-size-24">
                    <FiX style={{color: 'gray', marginBottom: '4px'}} className="clickable" onClick={() => onCloseDrawer()}></FiX>
                </Col>
                <Col>
                    <div className="text-black main-header text-size-24">Edit User: {props.user.first_name + ' ' + props.user.last_name}</div>
                </Col>
                <Col className='col-2'>
                    <Button 
                        block 
                        className='py-2 button-label' 
                        size='sm' 
                        style={{width: '75px'}}
                        color={Theme().colors.accentName}
                        onClick={handleSave}>Save
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{width: '100%', height: '1px', background: 'lightgray'}}></div>
                </Col>
            </Row>
            <Row style={{height: 'calc(100% - 230px)', overflowY: 'auto'}}>
                <Col className='mx-0 px-0'>
                    <Row className="mx-3">
                        <Col style={{overflowX: 'hidden'}}>
                            <Label className='label-text-header mt-2 mb-1' >Email Address</Label>
                            <Input placeholder='Type Email Address' value={email} onChange={(e) => setEmail(e.target.value)} />
                            {emailError && (
                              <Label className="text-danger">{emailError}</Label>
                            )}
                        </Col>
                        <Col>
                            <Label className='label-text-header mt-2 mb-1'>Role</Label>
                            <Select inputProps={{autoComplete: 'random-string', autofill:'off' }} placeholder='Select Role' options={roleOptions} onChange={(role) => setRole(role)} value={role} styles={selectStyles} />
                        </Col>
                    </Row>
                    <Row className='mx-3'>
                        <Col>
                            <Label className='label-text-header my-1' style={{color: 'gray', fontSize: '14px'}}>This Email Address will be used to log into the portal</Label>
                        </Col>
                    </Row>
                    <Row className="mx-3">
                        <Col className="h-fc" style={{ overflowX: 'hidden', position: 'relative' }}>
                            <Label className="label-text-header mt-2 mb-1">Password</Label>
                            <Input
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Type Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            />
                            <span
                            className="clickable"
                            style={{ position: 'absolute', top: '42px', right: '20px' }}
                            onClick={togglePasswordVisibility}
                            >
                            {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                            </span>
                        </Col>
                        <Col style={{ position: 'relative' }}>
                            <Label className="label-text-header mt-2 mb-1">Confirm Password</Label>
                            <Input
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Type Password Again"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                            <span
                            className="clickable"
                            style={{ position: 'absolute', top: '42px', right: '20px' }}
                            onClick={togglePasswordVisibility}
                            >
                            {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                            </span>
                        </Col>
                    </Row>
                    {passwordError && (
                    <Row className="mx-3">
                        <Col>
                        <Label className="text-danger">{passwordError}</Label>
                        </Col>
                    </Row>
                    )}
                    <Row className='mx-3'>
                        <Col>
                            <Label className='label-text-header my-1' style={{color: 'gray', fontSize: '14px'}}>This Password will be used to log into the portal</Label>
                        </Col>
                    </Row>
                    {isInternalAdmin &&
                    <>
                    <Row className='mx-3 mb-2'>
                        <Col className='w-fc'>
                            <Checkbox
                            defaultChecked={dashboardAccess}
                            onChange={(e) => setDashboardAccess(e.target.checked)}
                            sx={{
                                color: '#C04B7B',
                                '&.Mui-checked': {
                                color: '#C04B7B',
                                },
                            }}
                            />
                            <Label className='label-text-header' style={{top: '2px', position: 'relative'}}>Enable Access to MFR Dashboard</Label>
                        </Col>
                    </Row>
                    <Row className='mx-3 mb-2'>
                        <Col className='w-fc'>
                            <Checkbox
                            defaultChecked={salesStreamAccess}
                            onChange={(e) => setSalesStreamAccess(e.target.checked)}
                            sx={{
                                color: '#C04B7B',
                                '&.Mui-checked': {
                                color: '#C04B7B',
                                },
                            }}
                            />
                            <Label className='label-text-header' style={{top: '2px', position: 'relative'}}>Enable Access to SalesStream</Label>
                        </Col>
                    </Row>
                    <Row className='mx-3 mb-2'>
                        <Col className='w-fc'>
                            <Checkbox
                            defaultChecked={mfrItemScoreAccess}
                            onChange={(e) => setMfrItemScoreAccess(e.target.checked)}
                            sx={{
                                color: '#C04B7B',
                                '&.Mui-checked': {
                                color: '#C04B7B',
                                },
                            }}
                            />
                            <Label className='label-text-header' style={{top: '2px', position: 'relative'}}>Enable Access to MFR Item Score</Label>
                        </Col>
                    </Row>
                    </>
                    }
                    {/* <Row className='mx-4' style={{background: 'lightgray', gap: '1px', borderRadius: '8px'}}>
                        <Col className='px-0'>
                            <Row style={{background: 'white', borderRadius: '8px 8px 0px 0px', margin: '1px'}}>
                                <Col className='pt-2'>
                                    <Label className="text-black main-header text-size-16">Notification Preferences</Label>
                                </Col>
                            </Row>
                            <Row style={{gap: '1px', margin: '1px'}}>
                                <Col style={{alignContent: 'end', background: 'white'}}>
                                    <Label className="text-gray text-size-16">New Locations</Label>
                                </Col>
                                <Col style={{background: 'white'}}>
                                    <Checkbox
                                        onChange={(e) => setNewLocationsApp(e.target.checked)}
                                        checked={newLocationsApp}
                                        sx={{color: '#C04B7B', '&.Mui-checked': {color: '#C04B7B'}}}
                                    />
                                    <Label>App</Label>
                                    <Checkbox
                                        onChange={(e) => setNewLocationsEmail(e.target.checked)}
                                        checked={newLocationsEmail}
                                        sx={{color: '#C04B7B', '&.Mui-checked': {color: '#C04B7B'}}}
                                    />
                                    <Label>Email</Label>
                                </Col>
                            </Row>
                            <Row style={{gap: '1px', margin: '1px'}}>
                                <Col style={{alignContent: 'end', background: 'white'}}>
                                    <Label className="text-gray text-size-16">Lost Locations</Label>
                                </Col>
                                <Col style={{background: 'white'}}>
                                    <Checkbox
                                        onChange={(e) => setLostLocationsApp(e.target.checked)}
                                        checked={lostLocationsApp}
                                        sx={{color: '#C04B7B', '&.Mui-checked': {color: '#C04B7B'}}}
                                    />
                                    <Label>App</Label>
                                    <Checkbox
                                        onChange={(e) => setLostLocationsEmail(e.target.checked)}
                                        checked={lostLocationsEmail}
                                        sx={{color: '#C04B7B', '&.Mui-checked': {color: '#C04B7B'}}}
                                    />
                                    <Label>Email</Label>
                                </Col>
                            </Row>
                            <Row style={{gap: '1px', margin: '1px'}}>
                                <Col style={{alignContent: 'end', background: 'white'}}>
                                    <Label className="text-gray text-size-16">Change and Volume in Products</Label>
                                </Col>
                                <Col style={{background: 'white'}}>
                                    <Checkbox
                                        onChange={(e) => setProductChangesApp(e.target.checked)}
                                        checked={productChangesApp}
                                        sx={{color: '#C04B7B', '&.Mui-checked': {color: '#C04B7B'}}}
                                    />
                                    <Label>App</Label>
                                    <Checkbox
                                        onChange={(e) => setProductChangesEmail(e.target.checked)}
                                        checked={productChangesEmail}
                                        sx={{color: '#C04B7B', '&.Mui-checked': {color: '#C04B7B'}}}
                                    />
                                    <Label>Email</Label>
                                </Col>
                            </Row>
                            <Row style={{gap: '1px', margin: '1px'}}>
                                <Col style={{alignContent: 'end', background: 'white', borderRadius: '0px 0px 0px 8px'}}>
                                    <Label className="text-gray text-size-16">Change and Volume in Category</Label>
                                </Col>
                                <Col style={{background: 'white', borderRadius: '0px 0px 8px 0px'}}>
                                    <Checkbox
                                        onChange={(e) => setCategoryChangesApp(e.target.checked)}
                                        checked={categoryChangesApp}
                                        sx={{color: '#C04B7B', '&.Mui-checked': {color: '#C04B7B'}}}
                                    />
                                    <Label>App</Label>
                                    <Checkbox
                                        onChange={(e) => setCategoryChangesEmail(e.target.checked)}
                                        checked={categoryChangesEmail}
                                        sx={{color: '#C04B7B', '&.Mui-checked': {color: '#C04B7B'}}}
                                    />
                                    <Label>Email</Label>
                                </Col>
                            </Row>
                        </Col>
                    </Row> */}
                </Col>
            </Row>
            {canDelete && (
                <Row className='mx-0 px-2' style={{background: '#F8F8FA', width: '100%', height: '115px', position: 'absolute', bottom: '0px', borderTop: '1px solid #D3D8E0', boxShadow: '4px 0px 4px 0px #00000040'}}>
                    <Col className='w-fc' style={{alignContent: 'center'}}>
                        <FaUserAltSlash size={'58px'} color='#FA4D56'/>
                    </Col>
                    <Col style={{alignContent: 'center'}}>
                        <Row>
                            <Col className='m-0'>
                                <Label className='text-size-16 main-header'>Delete User Account</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className='text-size-12'>If you delete this account, this person will lose access to this portal and will be signed out of their account on all devices.</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col className='col-3' style={{alignContent: 'center'}}>
                        <Button 
                            block 
                            className='py-2 button-label' 
                            size='sm' 
                            style={{width: '118px'}}
                            color={'red'}
                            onClick={() => handleClickDeactivateUser()}>Delete User
                        </Button>
                    </Col>
                </Row>
            )}
        </div>
      </div>
    </Then>
    <Else>
      <div className="mask hide">
        <div className={(isMobile ? "side-drawer-mobile" : "side-drawer")}>
        </div>
      </div>
    </Else>
  </If>
  );
}

export default EditUserSlideDrawer;